import { OrderDto, OrderState, RolePermission } from 'desk-common';
import { User } from '../auth/authState';
import { ACTIONS_BY_STATE } from '../components/orders/constants/orderAction';
import userHasPermission from '../utils/functions/userHasPermission';
import { useMemo } from 'react';

export default function useOrderAvailableActions(
  order: OrderDto | null,
  user: User | null
) {
  return useMemo(() => {
    if (!order) {
      return { availableActions: [], showDraftButtons: true };
    }

    const canEditAllOrders = userHasPermission(user, RolePermission.editOrders);
    const canEditOwnOrders = userHasPermission(
      user,
      RolePermission.editOwnOrders
    );
    const canApprovePurchaserOrders = userHasPermission(
      user,
      RolePermission.approvePurchaseOrders
    );
    const canApproveCostCenterOrders =
      order.costCenter?.approverId === user?.email;
    const isOwner = order.userCreatedId === user?.email;

    const actionsByState = ACTIONS_BY_STATE(
      canApproveCostCenterOrders,
      canApprovePurchaserOrders,
      canEditAllOrders,
      canEditOwnOrders,
      isOwner
    );

    const actions = actionsByState[order.state] ?? [];

    const availableActions = actions.filter(
      ({ isAllowed }) => isAllowed === undefined || Boolean(isAllowed)
    );

    const showDraftButtons =
      !order ||
      (order.state === OrderState.BORRADOR &&
        ((order.userCreatedId === user?.email && canEditOwnOrders) ||
          canEditAllOrders));

    return { availableActions, showDraftButtons };
  }, [order, user]);
}
